import { render, staticRenderFns } from "./UpdateImg.vue?vue&type=template&id=cfcdc3e0&scoped=true&"
import script from "./UpdateImg.vue?vue&type=script&lang=js&"
export * from "./UpdateImg.vue?vue&type=script&lang=js&"
import style0 from "./UpdateImg.vue?vue&type=style&index=0&id=cfcdc3e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcdc3e0",
  null
  
)

export default component.exports